import { createSlice } from "@reduxjs/toolkit";
import {
  IFoundPlaces,
  IHouse,
} from "pages/OrderModal/components/SearchAddressInput/types";
import { IRoute } from "store/api/types";

interface ISrcAddress {
  address: IFoundPlaces;
  building: IHouse;
  entrance: string;
  comment: string;
  srcAddressRoute: IRoute;
}

const initialState: ISrcAddress = {
  address: {
    name: "",
    ["old_name"]: "",
    houses: [],
    locale: "",
  },
  building: {
    house: "",
    lat: 0,
    lng: 0,
  },
  entrance: "",
  comment: "",
  srcAddressRoute: {
    name: "",
    number: "",
    lat: 0,
    lng: 0,
  },
};

export const srcAddressSlice = createSlice({
  name: "srcAddress",
  initialState,
  reducers: {
    setSrcAddress: (state, { payload }) => {
      state.address = {
        name: payload.name,
        ["old_name"]: payload.old_name,
        houses: payload.houses,
        locale: payload.locale,
      };
    },
    removeSrcAddress: (state) => {
      state.address = initialState.address;
    },
    setSrcBuilding: (state, { payload }) => {
      state.building = {
        house: payload.house,
        lat: payload.lat,
        lng: payload.lng,
      };
    },
    removeSrcBuilding: (state) => {
      state.building = initialState.building;
    },
    setEntrance: (state, { payload }) => {
      state.entrance = payload.entrance;
    },
    removeEntrance: (state) => {
      state.entrance = "";
    },
    setComment: (state, { payload }) => {
      state.comment = payload.comment;
    },
    removeComment: (state) => {
      state.comment = "";
    },
    setSrcAddressRoute: (state, { payload }) => {
      state.srcAddressRoute = {
        name: payload.name,
        number: payload.number,
        lat: payload.lat,
        lng: payload.lng,
      };
    },
    removeSrcAddressRoute: (state) => {
      state.srcAddressRoute = initialState.srcAddressRoute;
    },
  },
});

export const {
  setSrcAddress,
  setSrcBuilding,
  setEntrance,
  setComment,
  removeSrcAddress,
  removeSrcBuilding,
  removeEntrance,
  removeComment,
  setSrcAddressRoute,
  removeSrcAddressRoute,
} = srcAddressSlice.actions;
export default srcAddressSlice.reducer;
